import React, { useState } from "react";
import { is } from "ramda";
import Tooltip from '@material-ui/core/Tooltip';

const ToggleTriangleButton = ({ onChange, size = 10, color = "#228B9D", opacity = 0.4, spacing = 1 }) => {

    const [show, setShow] = useState(true);
    const onClickUphandler = () => {
        setShow(true);
        if (is(Function, onChange)) {
            onChange(true)
        }
    }

    const onClickDownhandler = () => {
        setShow(false);
        if (is(Function, onChange)) {
            onChange(false)
        }
    }

    return (
        <div className="triangle-toggle">
            <style jsx>{` 
            .triangle-toggle {
                display: inline-block;
                margin-top: auto;
                margin-bottom: auto;
                // padding-left: 6px;
                vertical-align: middle;
            } 
            .triangle-up {
                width: ${size}px;
                height: ${size}px;
                border-left: ${size}px solid transparent;
                border-right: ${size}px solid transparent;
                border-bottom: ${size}px solid ${color};
                margin: ${spacing}px;
                margin-bottom: 2px;
                cursor: pointer;
            }
            .triangle-down {
                width: 0;
                height: 0;
                border-left: ${size}px solid transparent;
                border-right: ${size}px solid transparent;
                border-top: ${size}px solid ${color};
                margin: ${spacing}px;
                margin-top: 2px;
                cursor: pointer;
            }
            .icon-opacity {
                opacity: ${opacity};
            }
           
  `}
            </style>
            <Tooltip title="ascending">
                <div className={show ? "triangle-up" : "triangle-up icon-opacity"}
                    onClick={onClickUphandler}></div>
            </Tooltip>
            <Tooltip title="descending">
                <div className={show ? "triangle-down icon-opacity" : "triangle-down"}
                    onClick={onClickDownhandler}></div>
            </Tooltip>
        </div>
    );
};

export default ToggleTriangleButton;
